import LoginWithTOTP from '@pages/auth/login/2FA/LoginWithTOTP';
import LoginWithWebAuthn from '@pages/auth/login/2FA/LoginWithWebAuthn';
import Login from '@pages/auth/login/Login';
import LoginWithPassword from '@pages/auth/login/LoginWithPassword';
import SendMagicLink from '@pages/auth/login/SendMagicLink';
import VerifyMagicLink from '@pages/auth/login/VerifyMagicLink';
import Register from '@pages/auth/register/Register';
import DebugList from '@pages/debug/DebugList';
import { AnalyticsScreenName } from 'mh-client';
import { Route } from 'react-router';

const Names = AnalyticsScreenName.getInstance();

//TODO: fix being able to access certain routes when logged in
const AuthRoutes = (
    <>
        {import.meta.env.DEV && <Route path="/debug" element={<DebugList />} />}
        <Route
            path="/register"
            element={<Register />}
            handle={{ screen_name: Names.REGISTRATION }}
        />
        <Route
            path="/login"
            element={<Login />}
            handle={{ screen_name: Names.LOGIN_EMAIL }}
        />
        <Route
            path="/login/password/:setting?/:action?/:id?"
            element={<LoginWithPassword />}
            handle={{
                screen_name: (params: { setting?: string }) =>
                    params.setting
                        ? Names.REAUTH_PASSWORD
                        : Names.LOGIN_PASSWORD,
            }}
        />
        <Route
            path="/login/send-magic-link/:setting?/:action?/:id?"
            element={<SendMagicLink />}
            handle={{
                screen_name: (params: { setting?: string }) =>
                    params.setting
                        ? Names.REAUTH_MAGIC_LINK
                        : Names.LOGIN_MAGIC_LINK,
            }}
        />

        <Route
            path="/login/totp/:setting?/:action?/:id?"
            element={<LoginWithTOTP />}
            handle={{ screen_name: Names.LOGIN_TOTP }}
        />
        <Route
            path="/login/passkey/:setting?/:action?/:id?"
            element={<LoginWithWebAuthn />}
            handle={{
                screen_name: (params: { setting?: string }) =>
                    params.setting ? Names.REAUTH_PASSKEY : Names.LOGIN_PASSKEY,
            }}
        />
        {/* <Route path="/reauth" element={<ReauthPage />} /> */}
        <Route
            path="/login/magic-link/:setting?/:action?/:id?"
            element={<VerifyMagicLink />}
            handle={{ screen_name: Names.VERIFY_MAGIC_LINK }}
        />
    </>
);

export default AuthRoutes;
